import React, { useState } from "react";
import "../../../styles/pages/warehouse.css";
import { ProductCategoryDto } from "../../../api/productCategories";

interface Props {
  search: string;
  onSearchChange: (v: string) => void;
  filterType: "all" | "product" | "service";
  onFilterTypeChange: (v: "all" | "product" | "service") => void;
  filterStock: "all" | "in" | "out";
  onFilterStockChange: (v: "all" | "in" | "out") => void;
  filterCategory: number | "all";
  onFilterCategoryChange: (v: number | "all") => void;
  categories: ProductCategoryDto[];
  onResetFilters: () => void;
}

export default function StockTopBar({
  search, onSearchChange,
  filterType, onFilterTypeChange,
  filterStock, onFilterStockChange,
  filterCategory, onFilterCategoryChange,
  categories, onResetFilters,
}: Props) {
  const [filtersOpen, setFiltersOpen] = useState(false);
  const parentCategories = categories.filter((c) => c.folderId === null);
  const hasFilters = filterType !== "all" || filterStock !== "all" || filterCategory !== "all";

  return (
    <div className="stock-topbar">
      {/* Строка поиска + кнопка фильтров */}
      <div className="stock-topbar-row1">
        <div className="product-search-wrapper" style={{ flex: 1 }}>
          <input
            className="product-search"
            placeholder="Название или SKU"
            value={search}
            onChange={(e) => onSearchChange(e.target.value)}
          />
          {search.length > 0 && (
            <button className="product-search-clear" onClick={() => onSearchChange("")}>✕</button>
          )}
        </div>

        <button
          className={"stock-filter-toggle" + (hasFilters ? " active" : "")}
          onClick={() => setFiltersOpen(o => !o)}
        >
          {hasFilters ? "🔽 Фильтры ●" : (filtersOpen ? "🔼 Фильтры" : "🔽 Фильтры")}
        </button>
      </div>

      {/* Фильтры — раскрываются */}
      {filtersOpen && (
        <div className="stock-filters-panel">
          <select
            className="product-filter"
            value={filterType}
            onChange={(e) => onFilterTypeChange(e.target.value as any)}
          >
            <option value="all">Все типы</option>
            <option value="product">Товары</option>
            <option value="service">Услуги</option>
          </select>

          <select
            className="product-filter"
            value={filterStock}
            onChange={(e) => onFilterStockChange(e.target.value as any)}
          >
            <option value="all">Наличие: все</option>
            <option value="in">В наличии</option>
            <option value="out">Нет в наличии</option>
          </select>

          <select
            className="product-filter"
            value={filterCategory}
            onChange={(e) => onFilterCategoryChange(e.target.value === "all" ? "all" : Number(e.target.value))}
          >
            <option value="all">Все категории</option>
            {parentCategories.map((c) => (
              <option key={c.id} value={c.id}>{c.name}</option>
            ))}
          </select>

          <button className="product-reset-btn" onClick={() => { onResetFilters(); setFiltersOpen(false); }}>
            Сбросить
          </button>
        </div>
      )}
    </div>
  );
}
